import styled from 'styled-components';
import { device, frameHeight, getSpacing } from 'stylesheet';

export const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media ${device.tabletMax} {
    flex-wrap: row;
    background-color: #fffff7;
    position: fixed;
    width: 100%;
    z-index: 10;
    max-height: 15%;
  }

  @media ${device.laptopMin} {
    padding: ${getSpacing(2)} ${getSpacing(2)} ${getSpacing(2)} ${getSpacing(5)};
    height: ${frameHeight.header};
  }

  @media ${device.tabletMin} {
    flex-direction: row;
  }
`;
export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${getSpacing(1.5)};
`;
export const SelectionContainer = styled.div`
  @media ${device.tabletMax} {
    width: 40%;
    margin: 0 2px;
    height: ${frameHeight.header};
    padding: ${getSpacing(2.5)} 0;
  }
`;
export const UserContainer = styled.div`
  margin: 0 2px;
  height: ${frameHeight.header};
  padding: ${getSpacing(2)} 0;
`;

export const HeaderBrandImageContainer = styled.div`
  display: flex;
  align-items: center;
  height: ${frameHeight.header};
  padding: ${getSpacing(0.5)} 0;
`;

export const HeaderBrandImage = styled.img<{ $isCompact?: boolean }>`
  height: 100%;
  width: auto;
  max-height: ${({ $isCompact }) => ($isCompact ? '45px' : '68px')};
  max-width: 140px;
  object-fit: contain;

  @media ${device.tabletMax} {
    max-width: 75px;
    max-height: 36px;
  }
`;

export const CreateHamBurgerButtonContainer = styled.div`
  padding: ${getSpacing(1)} 0;
  @media ${device.laptop} {
    display: none;
  }
`;
